// RecivedOffersProvider.jsx
import React, { Suspense, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_DOMAIN } from "config";
import "../../styles/offers.css";
import { Heading, Img, Button } from "../../components";
import AllOffersProviderLinesRowSeven from "../../components/AllOffersProviderLinesRowSeven";
import ApprovedOffersProvider from "../../components/ApprovedOffersProvider";
import ApproveOfferByProviderPopup from "components/ApproveOfferByProviderPopup";

const tabs = ["הצעות שאושרו", "הצעות חדשות"];
const STATUS_MAP = { "הצעות חדשות": 1, "הצעות שאושרו": 2 };

export default function RecivedOffersProvider({ currentUser }) {
  const [activeTab, setActiveTab] = useState("הצעות חדשות");

  const [showApprovedOfferPopuop, setShowApprovedOfferPopuop] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);
  const [selectedOffer, setSelectedOffer] = useState(null);

  const [offerGroups, setOfferGroups] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [meta, setMeta] = useState({ page: 1, pageSize: 10, totalItems: 0, totalPages: 1 });
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // כשמחליפים טאב חוזרים לעמוד 1
  useEffect(() => {
    setPage(1);
  }, [activeTab]);

  // טעינה + רענון
  useEffect(() => {
    if (!currentUser?.id) return;

    let cancelled = false;

    const loadOffers = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${API_DOMAIN}/offer/getProviderReceivedOffers`, {
          params: {
            user_id: currentUser.id,
            status: STATUS_MAP[activeTab],
            page,
            pageSize,
          },
        });

        if (cancelled) return;

        setMeta(data.meta || { page: 1, pageSize, totalItems: 0, totalPages: 1 });

        const mapped = (data.data || []).map((b) => ({
          car: {
            ...b.car,
            images: (b.images || []).map((u) => ({ image_url: u })),
          },
          offers: (b.offers || []).map((o) => ({
            id: o.id,

            // שם
            buyerName: o.buyer_name || "",

            // איש קשר
            buyerContactName: o.buyer_contact_name,
            buyerPhoneNumber: o.buyer_phone_number,

            buyerId: o.user_id,
            offerDate: o.creation_date,
            offerPosition: o.offer_position,
            collectionDate: o.collection_date,
            lastPaymentDate: o.last_payment_date,
            price: o.offered_price,
            isReserved: o.is_reserved === 1,
            status: o.status,
            statusLabel: o.status === 1 ? "ממתין לאישור" : o.status === 2 ? "מאושר" : "נדחה",
          })),
        }));

        setOfferGroups(mapped);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadOffers();
    const intervalId = setInterval(loadOffers, 120000);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, [currentUser?.id, activeTab, page, pageSize]);

  const handlePopupClose = () => setShowApprovedOfferPopuop(false);
  const UpdateShowApprovedOfferPopup = (state) => setShowApprovedOfferPopuop(!!state);

  // כשמאשרים הצעה – להסיר מהרשימה בטאב "הצעות חדשות"
  const handleOfferApproved = (carId) => {
    setOfferGroups((prev) => prev.filter((g) => g.car.id !== carId));
  };

  // ✅ עוזר: מחזיר מקסימום 3 הצעות (הכי חדשות לפי תאריך)
  const getPreviewOffers = (offers) => {
    const arr = Array.isArray(offers) ? [...offers] : [];
    arr.sort((a, b) => {
      const da = new Date(a.offerDate || 0).getTime();
      const db = new Date(b.offerDate || 0).getTime();
      return db - da;
    });
    return arr.slice(0, 3);
  };

  const statusForNav = STATUS_MAP[activeTab]; // 1 או 2

  return (
    <>
      <Helmet>
        <title>הצעות מחיר שהתקבלו</title>
      </Helmet>

      <div className="flex bg-blue_gray-50 p-8 sm:p-4 wrap-recieved-offrers" style={{  paddingTop: "1rem" }}>
        <div className="w-[100%] items-start gap-4 md:flex-col" style={{ gap: "2%" }}>
          <div className="flex relative flex-1 flex-col gap-8 self-center rounded-[24px] bg-secondary-primary_white p-6 md:self-stretch sm:p-4">
            <header className="flex flex-col items-start gap-3">
              <div className="flex items-center justify-between gap-5 mt-5 self-stretch border-b border-solid border-gray-200 md:flex-col">
                <div className="flex items-center gap-3 w-full">
                  {/* תמונה שמאלה */}
                  <Img src="/images/ad-123.svg" alt="Car" className="mr-auto hide-mobile" />

                  {/* טאבים באמצע */}
                  <div className="w-full flex justify-center gap-4">
                    {tabs.map((tab) => (
                      <div
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        className={`px-4 py-2 cursor-pointer text-center ${
                          activeTab === tab ? "border-b-2 border-red-a700_03 text-black" : "text-gray-600"
                        }`}
                      >
                        {tab}
                      </div>
                    ))}
                  </div>

                  {/* כותרת ימינה */}
                  <Heading size="heading9xl" as="h4" className="!font-heebo text-[25px] font-bold lg:text-[21px]">
                    הצעות מחיר שהתקבלו
                  </Heading>

                  {/* אייקון ימינה */}
                  <Img src="/images/img_user_red_a700_03_1.svg" alt="User" className="h-[36px] hide-mobile" />
                </div>
              </div>
            </header>

            <div className="flex flex-col gap-6">
              <div>
                <Suspense fallback={<div>…טוען…</div>}>
                  {/* ✅ לכל רכב: מציגים רק 3 הצעות + כפתור "כל ההצעות" */}
                  {offerGroups.map((g) => {
                    const allOffers = Array.isArray(g.offers) ? g.offers : [];
                    const previewOffers = getPreviewOffers(allOffers);

                    return (
                      <div key={g.car.id} className="mb-8">
                        {activeTab === "הצעות שאושרו" ? (
                          <ApprovedOffersProvider
                            car={g.car}
                            rows={previewOffers} // ✅ רק 3
                            onOfferApproved={handleOfferApproved}
                            updateShowApprovedOfferPopup={UpdateShowApprovedOfferPopup}
                            setSelectedCar={setSelectedCar}
                            setSelectedOffer={setSelectedOffer}
                          />
                        ) : (
                          <AllOffersProviderLinesRowSeven
                            car={g.car}
                            rows={previewOffers} // ✅ רק 3
                            updateShowApprovedOfferPopup={UpdateShowApprovedOfferPopup}
                            onOfferApproved={handleOfferApproved}
                            setSelectedCar={setSelectedCar}
                            setSelectedOffer={setSelectedOffer}
                          />
                        )}

                        {/* ✅ כפתור "כל ההצעות" ליד הרכב */}
                        <div className="flex justify-end mt-3" dir="rtl">
                          <Button
                            size="lg"
                            shape="round"
                            className="rounded-[16px] border border-solid border-gray-300 px-4 py-2 font-semibold"
                            onClick={() => navigate(`/recived-offers/${g.car.id}?status=${statusForNav}`)}
                          >
                            כל ההצעות ({allOffers.length})
                          </Button>
                        </div>
                      </div>
                    );
                  })}
                </Suspense>

                {/* PAGINATION */}
                <div dir="rtl" className="flex items-center justify-between mt-6">
                  <div className="text-sm text-gray-600">
                    עמוד {meta.page} מתוך {meta.totalPages} | סה״כ רכבים: {meta.totalItems}
                  </div>

                  <div className="flex items-center gap-2">
                    <button
                      type="button"
                      className="px-3 py-1 border rounded-md disabled:opacity-40"
                      disabled={meta.page <= 1}
                      onClick={() => setPage((p) => Math.max(1, p - 1))}
                    >
                      הקודם
                    </button>

                    <button
                      type="button"
                      className="px-3 py-1 border rounded-md disabled:opacity-40"
                      disabled={meta.page >= meta.totalPages}
                      onClick={() => setPage((p) => Math.min(meta.totalPages, p + 1))}
                    >
                      הבא
                    </button>

                    <div className="relative">
                      <select
                        dir="rtl"
                        value={pageSize}
                        onChange={(e) => {
                          setPageSize(Number(e.target.value));
                          setPage(1);
                        }}
                        className="border rounded-md pl-9 pr-3 py-1 text-sm text-right bg-white appearance-none bg-none"
                        style={{
                          WebkitAppearance: "none",
                          MozAppearance: "none",
                          appearance: "none",
                          backgroundImage: "none",
                        }}
                      >
                        {[10, 5, 3, 2, 1].map((n) => (
                          <option key={n} value={n}>
                            {n} רכבים בעמוד
                          </option>
                        ))}
                      </select>

                      {/* חץ מותאם אישית בצד שמאל */}
                      <Img
                        src="/images/img_vector_red_a700_03_10.svg"
                        alt="arrow"
                        className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 h-[10px] w-[10px] opacity-70"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* POPUP לאחר אישור */}
            {showApprovedOfferPopuop && (
              <ApproveOfferByProviderPopup onClose={handlePopupClose} car={selectedCar} offer={selectedOffer} />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
